import { NotificationType as PrismaNotificationType } from '@prisma/client';

export enum NotificationChannel {
  WEBSOCKET = 'websocket',
  EMAIL = 'email',
  SMS = 'sms'
}

// Use Prisma NotificationType as the main type
export type NotificationType = PrismaNotificationType;

// Extended notification subtypes for interactions not directly in Prisma
export type ExtendedNotificationType =
  | NotificationType
  | 'INTERACTION_FAVOURITE'
  | 'INTERACTION_COMMENT'
  | 'INTERACTION_RATING'
  | 'INTERACTION_VIEW'
  | 'APPOINTMENT_RESCHEDULED'
  | 'APPOINTMENT_CANCELLED'
  | 'ORDER_CONFIRMED'
  | 'ORDER_STATUS_CHANGED';

// Type definition for interaction types
export type InteractionType =
  | 'FAVOURITE'
  | 'COMMENT'
  | 'RATING'
  | 'SHARE'
  | 'MENTION'
  | 'DOWNLOAD'
  | 'PURCHASE'
  | 'VIEW';

export interface NotificationData {
  datetime?: string;
  shopLocation?: string;
  actionUrl?: string;
  actionRequired?: boolean;
  deadline?: string;
  details?: string;
  startupTime?: string;
  environment?: string;
  sesConfig?: {
    region: string;
    hasCredentials: boolean;
  };

  // Content interaction specific fields
  contentType?: string;
  contentId?: string;
  contentTitle?: string;
  contentSlug?: string;
  interactionId?: string;
  interactionType?: string;

  // User information
  actorId?: string;
  actorName?: string;
  actorUsername?: string;
  actorImage?: string;

  // Purchase/download specific
  purchaseId?: string;
  purchaseAmount?: number;
  purchaseCurrency?: string;
  downloadId?: string;

  // Timestamps
  timestamp?: string;

  // Additional dynamic data
  [key: string]: unknown;
}

export interface NotificationResponse {
  success: boolean;
  error?: string;
  data?: unknown;
}

export interface NotificationBase {
  type: ExtendedNotificationType;
  title: string;
  message: string;
  data?: NotificationData;
  recipientId: string;
  channels?: NotificationChannel[];
  metadata?: {
    overrideEmail?: string;
    [key: string]: unknown;
  };
}

export interface NotificationItem extends NotificationBase {
  id: string;
  read: boolean;
  archived: boolean;
}

export type NotificationEvent = {
  id: string;
  type: string;
  data: Record<string, unknown>;
  userId?: string;
}

export type NotificationSocketEvents = {
  [key: string]: (data: NotificationEvent) => void;
}

export type ClientToServerEvents = {
  [key: string]: (data: NotificationEvent) => void | Promise<void>;
}
